import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';

export const customerOrderGet = async (orderId: string): Promise<CartResponse> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/order-management/orders/${orderId}`,
    params: orderId,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<CartResponse>(emeraldRequestParams);
};
